import { IDEMPOTENCE_KEY_HEADER_NAME as e } from "../app/constants.js";
import { IdempotenceKeyManager as s } from "./idempotenceKeyManager.js";
const a = (a2) => ({ baseUrl: r } = { baseUrl: "" }) => async (t, o) => {
  var _a, _b, _c, _d;
  const { url: n, method: p, data: d, params: c, headers: m, responseType: i, transformResponse: u, meta: l } = t;
  try {
    let t2 = { ...m };
    const f = ((_a = o.endpoint) == null ? void 0 : _a.toLowerCase()) || "";
    if (f.includes("create") || f.includes("update")) {
      const a3 = s.ensureKey();
      t2 = { ...t2, [e]: a3 };
    }
    return { data: (await a2({ url: r + n, method: p, data: d, params: c, headers: t2, responseType: i, transformResponse: u })).data, meta: l };
  } catch (e2) {
    const s2 = e2;
    return { error: { status: (_b = s2.response) == null ? void 0 : _b.status, data: (_c = s2.response) == null ? void 0 : _c.data, message: s2.message, headers: (_d = s2.response) == null ? void 0 : _d.headers, config: s2.config, originalError: s2 } };
  }
};
export {
  a as default,
  a as initializeAxiosBaseQuery
};
//# sourceMappingURL=axiosBaseQuery.js.map
